import { useEffect, useState } from 'react';
import { useCreateOrganizationAnonymousSession } from './create-organization-anonymous-session';

type TSessionData = {
  session_id: string;
  centralized_organization_id: string;
};

export const useCreateSession = (originalId: number | undefined | null) => {
  const [createOrganizationAnonymousSession] =
    useCreateOrganizationAnonymousSession();
  const [sessionData, setSessionData] = useState<TSessionData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const createSession = async (orgId: number | undefined | null) => {
    setLoading(true);
    if (!orgId) {
      return;
    }

    try {
      const result = await createOrganizationAnonymousSession({
        variables: {
          input: {
            centralized_organization_id: orgId.toString(),
          },
        },
      });

      const sessionPayload =
        result.data?.security
          .create_centralized_organization_anonymous_jwt_session;
      if (sessionPayload && 'session_id' in sessionPayload) {
        setSessionData(sessionPayload);
      }
    } catch (error) {
      console.error('Error to create session', error);
      setError('Error to create session');
    } finally {
      setLoading(false);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: no need to depend on createSession
  useEffect(() => {
    if (!originalId) {
      setLoading(false);
      return;
    }

    createSession(originalId);
  }, [originalId, createOrganizationAnonymousSession]);

  return { sessionData, loading, error, createSession };
};
